import { useFetch } from '../../hooks/useFetch';

/**
 * @param {import('../../types/dashboard').DashboardRefreshParams} [params]
 * @returns {Promise<import('../../types/dashboard').DashboardAttention>}
 */
export const FetchDashboardAttention = async (params) => {
  const body = await useFetch('/dashboard/attention', params);

  return body.data;
};
